import { setAuthCache } from '/@/utils/auth'
import { TOKEN_KEY } from '/@/enums/cacheEnum'
import { useGlobSetting } from '/@/hooks/setting'

const globSetting = useGlobSetting()

// 刷新 token 的状态管理
let isRefreshing = false // 当前是否正在刷新 token
let refreshPromise: Promise<any> | null = null // 刷新 token 的 Promise 实例

// 默认的刷新凭证配置
const REFRESH_CREDENTIALS = {
  userName: 'front_end',
  password: 'front_end123',
}

/**
 * 刷新 token
 * @returns Promise<string> 返回新的 token
 */
async function refreshTokenRequest(): Promise<string> {
  const response = await fetch(`${globSetting.apiUrl}/user-center/userLogin/pwd/login`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(REFRESH_CREDENTIALS),
  })

  const result = await response.json()

  if (result && result.data && result.data.token) {
    return result.data.token
  }

  throw new Error('刷新 token 失败')
}

/**
 * 刷新 token 的主函数
 * 使用单例模式，确保同一时间只有一个刷新请求
 */
export async function refreshToken(): Promise<string> {
  // 如果当前正在刷新，返回已有的 Promise
  if (isRefreshing && refreshPromise) {
    return refreshPromise
  }

  // 开始刷新
  isRefreshing = true
  refreshPromise = refreshTokenRequest()
    .then((newToken) => {
      // 保存新的 token
      setAuthCache(TOKEN_KEY, newToken)
      isRefreshing = false
      refreshPromise = null
      return newToken
    })
    .catch((error) => {
      isRefreshing = false
      refreshPromise = null
      throw error
    })

  return refreshPromise
}

/**
 * 检查是否正在刷新 token
 */
export function isRefreshingToken(): boolean {
  return isRefreshing
}

/**
 * 获取刷新 token 的 Promise
 */
export function getRefreshPromise(): Promise<string> | null {
  return refreshPromise
}
